









































import { Component, Emit, Watch } from 'nuxt-property-decorator'
import { cloneDeep } from 'lodash'
import { ModalComponentBaseVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import { SystemCodeKey, SystemParameterKey } from '@/api'
import {
  modalCodeKeyStore,
  systemCodeKeyStore,
  systemParameterKeyStore
} from '@/store'
import {
  CodeKeyTable,
  TableItem,
  defaultTableItem
} from '@/components/organisms/CodeKeyTable'
@Component({
  components: {
    CodeKeyTable,
    ModalFooter
  }
})
export default class ModalCodeKey extends ModalComponentBaseVue {
  items: TableItem[] = []

  tableBodyHeight: number = 0

  get displayFormat(): string {
    return this.isSystemCode ? 'システムコード' : 'システムパラメーター'
  }

  get title(): string {
    return this.isSystemCode ? 'コードキーマスタ' : 'パラメーターキーマスタ'
  }

  get isOpen(): boolean {
    return modalCodeKeyStore.isOpen
  }

  get isSystemCode(): boolean {
    return modalCodeKeyStore.isSystemCode
  }

  get defaultCodeKey(): string {
    return modalCodeKeyStore.defaultCodeKey
  }

  get systemKeys(): (SystemCodeKey | SystemParameterKey)[] {
    if (this.isSystemCode) return systemCodeKeyStore.allItems
    return systemParameterKeyStore.allItems
  }

  get selectedItem(): TableItem {
    return (
      this.items.find(item => item.isSelected) ?? cloneDeep(defaultTableItem)
    )
  }

  @Watch('isOpen')
  reconfigureTableBodyHeightOnChangeDialog(): void {
    if (this.isOpen) this.$nextTick(this.calculateTableHeight)
  }

  @Watch('isOpen')
  opened(): void {
    this.createInternalItems()
  }

  mounted() {
    this.debug('mounted()')
    window.addEventListener('resize', this.calculateTableHeight)
  }

  beforeDestroy() {
    this.debug('beforeDestroy()')
    window.removeEventListener('resize', this.calculateTableHeight)
  }

  calculateTableHeight(): void {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()
    })
  }

  createInternalItems() {
    this.debug('createInternalItems()')
    this.items = this.systemKeys.map(value => {
      return {
        isSelected: value.key === this.defaultCodeKey,
        ...value
      }
    })
  }

  onClickOk(): void {
    modalCodeKeyStore.ok(this.selectedItem)
  }

  onClickCancel(): void {
    modalCodeKeyStore.cancel()
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-code-key')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  @Emit('change')
  onSelectCode(codeKey: string): void {
    this.items.some(item => {
      if (item.key === codeKey) {
        item.isSelected = true
        return false
      }
      item.isSelected = false
    })
  }
}
